// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview-content[data-v-7ae0350b] {\n  color: #000;\n  border-left: 3px solid #ffe4c4;\n  padding-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
